import { render, staticRenderFns } from "./SalesUnitForm.vue?vue&type=template&id=60050c74"
import script from "./SalesUnitForm.vue?vue&type=script&lang=js"
export * from "./SalesUnitForm.vue?vue&type=script&lang=js"
import style0 from "./SalesUnitForm.vue?vue&type=style&index=0&id=60050c74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports